import { OrthoTileStore } from './ortho-tile-store';

/**
 * Default OSM tile URL (matches OpenLayers OSM source).
 * Uses a single subdomain; for production you may use {a-c}.tile.openstreetmap.org for load balancing.
 */
const DEFAULT_OSM_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

export type OsmOrthoTileStoreOptions = {
  url?: string;
};

/**
 * OrthoTileStore that loads tiles from an XYZ URL template (e.g. OpenStreetMap).
 * Use as the default store when no WMS options are provided.
 */
export class OsmOrthoTileStore implements OrthoTileStore {
  private readonly urlTemplate: string;

  constructor(options?: OsmOrthoTileStoreOptions) {
    this.urlTemplate = options?.url ?? DEFAULT_OSM_URL;
  }

  async loadTileUrl(zoom: number, column: number, row: number): Promise<string> {
    return Promise.resolve(
      this.urlTemplate
        .replace('{z}', String(zoom))
        .replace('{x}', String(column))
        .replace('{y}', String(row)),
    );
  }
}
